import classNames from 'classnames';
import React from 'react';
import { AlertType } from '../../../../../../../components/Alert';
import styles from '../../../../styles.module.scss';

export interface PropTypes {
  content: string;
  contentType?: string;
  onAlert: (message: string, alertType: AlertType) => void;
}

export default function CopyButton(props: PropTypes) {
  async function handleCopyButtonClick() {
    await navigator.clipboard.writeText(props.content);
    props.onAlert(`${props.contentType} has been copied!`, AlertType.Success);
  }

  return (
    <>
      <div onClick={handleCopyButtonClick}>
        <i
          className={classNames('bi bi-files text-info', styles.cursorPointer)}
        ></i>
      </div>
    </>
  );
}
